import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Skeleton } from '@chakra-ui/react';
export const CardSkeleton = ({ aspectRatio, bodyHeight, ...rest }) => (_jsxs(Skeleton, { width: "100%", ...rest, children: [_jsx(Box, { aspectRatio: aspectRatio }), bodyHeight && _jsx(Box, { height: bodyHeight })] }));
